import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/app")({
  component: AppLayout,
});

function AppLayout() {
  return (
    <div className="flex min-h-0 w-full min-w-0 flex-1 justify-center">
      <Outlet />
    </div>
  );
}
